var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.459,
    height: 17.368,
    viewBox: "0 0 16.459 17.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11349",
    "data-name": "Group 11349",
    transform: "translate(-1483.271 0.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726",
    transform: "translate(1484 0.394)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_449",
    "data-name": "Line 449",
    x1: 15,
    y1: 16,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3d95c8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_451",
    "data-name": "Line 451",
    y1: 16,
    x2: 15,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#3d95c8",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCancel);
export default __webpack_public_path__ + "static/media/Cross_Cancel.2251934b264f82e8f9bf5320041b1c55.svg";
export { ForwardRef as ReactComponent };